/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import moment from 'moment'

type Props = {
  className: string
}

const TablesWidget5: React.FC<Props> = ({className}) => {
  const [showBookingDetails, setShowBookingDetails] = useState(false)
  const [upcomingTours, setUpcomingTours] = useState([]);
  const [completedTours, setCompletedTours] = useState([]);
  const [customerName, setCustomerName] = useState('');
  const [openBookingId, setOpenBookingId] = useState(null);
  const { id } = useParams();

  const handleBookingDetailsClick = (index:any) => {
    setOpenBookingId((prevId) => (prevId === index ? null : index));
  };

  useEffect(() => {
    axios.get("https://api.protechnologys.in/public/index.php/api/getUpcomingTours/" + id)
    .then((response) => {
      if (response.status == 200) {
        setUpcomingTours(response.data.upcoming_tours);
      }
    });

    axios.get("https://api.protechnologys.in/public/index.php/api/getCompletedTours/" + id)
    .then((response) => {
      if (response.status == 200) {
        setCompletedTours(response.data.completed_tours);
      }
    })

    axios.get("https://api.protechnologys.in/public/index.php/api/getUserProfile/" + id)
    .then((response) => {
      console.log(response.data);
      if(response.status == 200)
      {
        if(response.data.status)
        {
          setCustomerName(response.data.user.name);
        }
      }
    });
  },[]);

  return (
    <>
    <div className={`card1 bg-white rounded p-9 ${className}`}>
      {/* begin::Header */}
      {upcomingTours.map((item:any, index: number) => (
        <>
          <div className='card-header border-0 my-5'>
            <div className='col-lg-11'>
              <div className='card1 border-neutral-300 rounded p-5'>
                <div className='ml-1 h-8 p-2 rounded text-sm uppercase font1 text-orange-500 font-medium'>
                  {item.package.tour_city} Tour
                </div>
                <h5 className='font-medium text-lg1 text-teal-600 mt-3 mb-5 ml-1'>
                  {item.package.tour_title}
                </h5>
                <div className='text-left col-lg-12 xl:mt-4 md:mt-4 mt-2 items-center xl:gap-12'>
                  <div className='col-lg-12 flex'>
                    <div className='col-lg-2 border-r p-1 '>
                      <h4 className='font1 font-medium text-slate-500 text-base1'>Booked on</h4>
                      <div className='font-medium text-slate-500 font text-sm'>{new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(item.checkout.created_at))}</div>
                    </div>
                    <div className='col-lg-3 xl:border-r lg:border-r md:border-r p-1 ml-1'>
                      <h4 className='font1 font-medium text-slate-500 text-base1'>Travelled Date</h4>
                      <div className='font-medium text-slate-500 font text-sm'>{`${moment(item.checkout.check_in_date).format('MMM D')} - ${moment(item.checkout.check_out_date).format('MMM D, YY')}`}</div>
                    </div>
                    <div className='col-lg-3 xl:border-r lg:border-r md:border-r p-1 ml-1'>
                      <h4 className='font1 font-medium text-slate-500 text-base1'></h4>
                      <div className='font-medium text-slate-500 font text-sm'></div>
                    </div>
                    <div className='col-lg-6 flex'>
                      <button
                        className='ml-3 text-white bg-orange-400 px-5 h-12 ml-2 rounded '
                        onClick={() => handleBookingDetailsClick(item.checkout.id)}
                      >
                        Booking Details
                      </button>
                    </div>
                  </div>
                </div>
                {/* Render the new card1 type box below if showBookingDetails is true */}
              </div>
            </div>
          </div>
          {openBookingId === item.checkout.id && (
            <div className='card1 flex col-lg-11 bg-white rounded p-5 mt-4'>
              {/* Content for the new card goes here */}
              <div className='col-lg-12 flex'>
                <div className='col-lg-8'>
                  <div className='ml-1 w-24 h-8 p-2 rounded text-sm uppercase font1 text-orange-500 font-medium'>
                    {item.package.tour_city} Tour
                  </div>
                  <h5 className='ml-1 font-medium text-lg1 text-teal-600 mt-3 mb-5'>
                    {item.package.tour_title}
                  </h5>
                  <div className='col-lg-12'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booked on</h4>
                        <div className='font-medium text-slate-500 font text-sm'>{new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(item.checkout.created_at))}</div>
                      </div>
                      <div className='col-lg-3 border-r p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Travelled Date</h4>
                        <div className='font-medium text-slate-500 font text-sm'>{`${moment(item.checkout.check_in_date).format('MMM D')} - ${moment(item.checkout.check_out_date).format('MMM D, YY')}`}</div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12 mt-6'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booking Branch</h4>
                        <div className='font-medium text-slate-500 font text-sm'>Bangalore</div>
                      </div>
                      <div className='col-lg-3 border-r p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booking Person</h4>
                        <div className='font-medium text-slate-500 font text-sm'> {customerName}</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Form Number</h4>
                        <div className='font-medium text-slate-500 font text-sm'>DUBAITRAWEL2022</div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12 mt-6'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Tour Manager</h4>
                        <div className='font-medium text-slate-500 font text-sm'>Kishore Kumar</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Tour Manager No</h4>
                        <div className='font-medium text-slate-500 font text-sm'>9876543210</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'></h4>
                        <div className='font-medium text-slate-500 font text-sm'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 card1 rounded p-5'>
                  <div>
                    <div className='font-medium  text-xl  text-teal-600 '>Payment</div>
                    <h4 className='font1 font-medium text-slate-600 mt-4 text-base1 '>Total Amount</h4>
                    <div className='font-medium text-slate-500 font text-sm'>₹{item.checkout.total_amount}</div>
                  </div>
                  <div>
                    <h4 className='font1 font-medium text-slate-600 mt-4 text-base1'>Amount Paid</h4>
                    <div className='font-medium text-slate-500 font text-sm'>₹{item.checkout.paid_amount ? item.checkout.paid_amount : '0'}</div>
                  </div>
                  <div className='col-lg-12 flex mt-6'>
                    <div className='col-lg-10'>Balance Amount</div>
                    <div className='col-lg-2 text-danger -pt-2'>₹{item.checkout.paid_amount ? item.checkout.total_amount - item.checkout.paid_amount : item.checkout.total_amount}</div>
                  </div>
                  <div className='mt-4 text-center'>
                    <a href="#!" className='text-teal-500 underline cursur-pointer'>View Price Breakup</a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ))}
      {completedTours.map((item:any, index: number) => (
        <>
          <div className='card-header border-0 my-5'>
            <div className='col-lg-11'>
              <div className='card1 border-neutral-300 rounded p-5'>
                <div className='ml-1 h-8 p-2 rounded text-sm uppercase font1 text-orange-500 font-medium'>
                  {item.package.tour_city} Tour
                </div>
                <h5 className='font-medium text-lg1 text-teal-600 mt-3 mb-5 ml-1'>
                  {item.package.tour_title}
                </h5>
                <div className='text-left col-lg-12 xl:mt-4 md:mt-4 mt-2 items-center xl:gap-12'>
                  <div className='col-lg-12 flex'>
                    <div className='col-lg-2 border-r p-1 '>
                      <h4 className='font1 font-medium text-slate-500 text-base1'>Booked on</h4>
                      <div className='font-medium text-slate-500 font text-sm'>{new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(item.checkout.created_at))}</div>
                    </div>
                    <div className='col-lg-3 xl:border-r lg:border-r md:border-r p-1 ml-1'>
                      <h4 className='font1 font-medium text-slate-500 text-base1'>Travelled Date</h4>
                      <div className='font-medium text-slate-500 font text-sm'>{`${moment(item.checkout.check_in_date).format('MMM D')} - ${moment(item.checkout.check_out_date).format('MMM D, YY')}`}</div>
                    </div>
                    <div className='col-lg-3 xl:border-r lg:border-r md:border-r p-1 ml-1'>
                      <h4 className='font1 font-medium text-slate-500 text-base1'></h4>
                      <div className='font-medium text-slate-500 font text-sm'></div>
                    </div>
                    <div className='col-lg-6 flex'>
                      <button
                        className='ml-3 text-white bg-orange-400 px-5 h-12 ml-2 rounded '
                        onClick={() => handleBookingDetailsClick(item.checkout.id)}
                      >
                        Booking Details
                      </button>
                    </div>
                  </div>
                </div>
                {/* Render the new card1 type box below if showBookingDetails is true */}
              </div>
            </div>
          </div>
          {openBookingId === item.checkout.id && (
            <div className='card1 flex col-lg-11 bg-white rounded p-5 mt-4'>
              {/* Content for the new card goes here */}
              <div className='col-lg-12 flex'>
                <div className='col-lg-8'>
                  <div className='ml-1 w-24 h-8 p-2 rounded text-sm uppercase font1 text-orange-500 font-medium'>
                    {item.package.tour_city} Tour
                  </div>
                  <h5 className='ml-1 font-medium text-lg1 text-teal-600 mt-3 mb-5'>
                    {item.package.tour_title}
                  </h5>
                  <div className='col-lg-12'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booked on</h4>
                        <div className='font-medium text-slate-500 font text-sm'>{new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(item.checkout.created_at))}</div>
                      </div>
                      <div className='col-lg-3 border-r p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Travelled Date</h4>
                        <div className='font-medium text-slate-500 font text-sm'>{`${moment(item.checkout.check_in_date).format('MMM D')} - ${moment(item.checkout.check_out_date).format('MMM D, YY')}`}</div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12 mt-6'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booking Branch</h4>
                        <div className='font-medium text-slate-500 font text-sm'>Bangalore</div>
                      </div>
                      <div className='col-lg-3 border-r p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Booking Person</h4>
                        <div className='font-medium text-slate-500 font text-sm'> {customerName}</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Form Number</h4>
                        <div className='font-medium text-slate-500 font text-sm'>DUBAITRAWEL2022</div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12 mt-6'>
                    <div className='flex'>
                      <div className='col-lg-3 border-r p-1 '>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Tour Manager</h4>
                        <div className='font-medium text-slate-500 font text-sm'>Kishore Kumar</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'>Tour Manager No</h4>
                        <div className='font-medium text-slate-500 font text-sm'>9876543210</div>
                      </div>
                      <div className='col-lg-3 p-1 ml-1'>
                        <h4 className='font1 font-medium text-slate-500 text-base1'></h4>
                        <div className='font-medium text-slate-500 font text-sm'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 card1 rounded p-5'>
                  <div>
                    <div className='font-medium  text-xl  text-teal-600 '>Payment</div>
                    <h4 className='font1 font-medium text-slate-600 mt-4 text-base1 '>Total Amount</h4>
                    <div className='font-medium text-slate-500 font text-sm'>₹{item.checkout.total_amount}</div>
                  </div>
                  <div>
                    <h4 className='font1 font-medium text-slate-600 mt-4 text-base1'>Amount Paid</h4>
                    <div className='font-medium text-slate-500 font text-sm'>₹{item.checkout.paid_amount ? item.checkout.paid_amount : '0'}</div>
                  </div>
                  <div className='col-lg-12 flex mt-6'>
                    <div className='col-lg-10'>Balance Amount</div>
                    <div className='col-lg-2 text-danger -pt-2'>₹{item.checkout.paid_amount ? item.checkout.total_amount - item.checkout.paid_amount : item.checkout.total_amount}</div>
                  </div>
                  <div className='mt-4 text-center'>
                    <a href="#!" className='text-teal-500 underline cursur-pointer'>View Price Breakup</a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ))}
    </div>
    </>
  )
}

export {TablesWidget5}
